import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import requirementsRoutes from 'modules/requirements/common/routing/routes'
import routes from './routes'

export { routes }

const { RouteChangeProgress } = common

export const RequirementCompletionDetailsRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "RequirementsRequirementCompletionDetails" */ 'modules/requirements/RequirementCompletionDetails/pages/RequirementCompletionDetails'
    )
)

const RequirementCompletionDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route
        exact
        path={`${routes.root}/:requirementId`}
        component={RequirementCompletionDetailsRoute}
      />

      <Redirect path='*' to={requirementsRoutes.root} />
    </Switch>
  </Suspense>
)

export default RequirementCompletionDetailsRouting
